const isValidIconElement = (iconList, id) => {
  if (!Array.isArray(iconList) || typeof id !== 'string') {
    return false;
  }

  return iconList.some(icon => typeof icon === 'string' && icon === id);
};

export default isValidIconElement;
